export default {
	listOfDeals:          state => state.listOfDeals,
	listOfPublicDeals:      state => state.listOfPublicDeals,
	listOfSuccessStories:      state => state.listOfSuccessStories,
	videoGuidesErrors:    state => state.videoGuidesErrors
};
